import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  withStyles,
  Typography,
  Divider,
  Button,
  Container,
} from "@material-ui/core";
import { blue, orange, grey, green, red } from "@material-ui/core/colors";
import ReactToPrint from "react-to-print";



import queryString from "query-string";
import { PostData } from "../../../api/service";

const styles = (theme) => ({});

class ReceiptPrint extends Component {
  state = {
    data: [],
    isLoaded: false,
  };

  componentDidMount() {
  
    let search = this.props.history.location.search;

    let searchData = queryString.parse(search);
   
      PostData(`/getpaymentreceiptcertificate`, {
        certificate_request_id: searchData.certificate_request_id,
      }).then((resp) => {
        if (Array.isArray(resp) && resp.length > 0) {
          this.setState({
            data: resp[0],
            isLoaded: true,
          });
        } else {
          //this.props.history.replace('/home')
        }
      });
    
  }

  render() {
    let { classes } = this.props;
    return (
      <div>
        <Container>
          <br />
          <br />
          

        

          {this.state.isLoaded && (
            <Receipt
              {...this.state.data}
              ref={(el) => (this.componentRef = el)}
            />
          )}

          <br />
          <br />

          {this.state.isLoaded ? (
            <div>
              <ReactToPrint
                trigger={() => (
                  <Button variant="outlined" color="primary">
                    Print Receipt
                  </Button>
                )}
                ref={(el) => (this.buttonRef = el)}
                content={() => this.componentRef}
                pageStyle={{ margin: "10px" }}
                copyStyles={true}
              />
            </div>
          ) : null}
        </Container>
      </div>
    );
  }
}

export default withStyles(styles)(ReceiptPrint);

class Receipt extends Component {
  goodSemester = (course, semester) => {
    if (course == "HSA" || course == "HSS" || course == "HSC") {
      if (semester == 1) {
        return "1st Year";
      }
      if (semester == 2) {
        return "2nd Year";
      }
    } else {
      if (semester == 1) {
        return "1st Semester";
      }
      if (semester == 2) {
        return "2nd Semester";
      }
      if (semester == 3) {
        return "3rd Semester";
      }
      if (semester == 4) {
        return "4th Semester";
      }
      if (semester == 5) {
        return "5th Semester";
      }
      if (semester == 6) {
        return "6th Semester";
      }
      if (semester == 7) {
        return "7th Semester";
      }
      if (semester == 8) {
        return "8th Semester";
      }
    }
  };

  render() {
    return (
      <div>
        <table width="100%">
          <tbody>
            <tr>
              <td width="20%">
                <img
                  alt="logo"
                  src={"/icon512.png"}
                  style={{ width: "50%" }}
                />
              </td>

              <td width="60%" align="center">
                <Typography variant="h5">Rangia College</Typography>
                <Typography variant="body2">
                  Rangia, Kamrup (R) - 781354, ASSAM
                </Typography>
                <Typography variant="body2">Assam</Typography>
                <Typography variant="body1">Payment Receipt</Typography>
              </td>

              <td width="20%" align="center"></td>
            </tr>
          </tbody>
        </table>

        <br />
        <br />

        <table className="table">
          <tbody>
            <tr>
              <td width="30%">
                <Typography variant="body2">Name</Typography>
              </td>

              <td>
                <Typography variant="body2" style={{fontWeight: 500}}>{this.props.name}</Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2" >Father's Name</Typography>
              </td>

              <td>
                <Typography variant="body2" style={{fontWeight: 500}}>
                  {this.props.father_name}
                </Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Class</Typography>
              </td>

              <td>
                <Typography variant="body2" style={{fontWeight: 500}}>
                  {this.props.course}{" "}
                  {this.goodSemester(this.props.course, this.props.semester)}
                </Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Certificate ID</Typography>
              </td>

              <td>
                <Typography variant="body2" style={{fontWeight: 500}}>{this.props.id}</Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Certificate Type</Typography>
              </td>

              <td>
                <Typography variant="body2" style={{fontWeight: 500}}>{this.props.type_name}</Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Transaction Status</Typography>
              </td>

              <td>
                <Typography variant="body2" style={{fontWeight: 500}}>Success</Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Tracking ID</Typography>
              </td>

              <td>
                <Typography variant="body2" style={{fontWeight: 500}}>
                  {this.props.tracking_id}
                </Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Bank Ref No</Typography>
              </td>

              <td>
                <Typography variant="body2" style={{fontWeight: 500}}>
                  {this.props.bank_ref_no}
                </Typography>
              </td>
            </tr>

            {/* <tr>
                            <td width="30%">
                                <Typography
                                    variant="body2"
                                >
                                    Bank Ref No.
                                </Typography>
                            </td>

                            <td>
                                <Typography
                                    variant="body2"
                                >
                                    {this.props.transaction != null && this.props.transaction.bank_ref_no}
                                    {this.props.transaction == null && this.props.transaction_id}
                                </Typography>
                            </td>
                        </tr> */}

            <tr>
              <td width="30%">
                <Typography variant="body2">Date of Payment</Typography>
              </td>

              <td>
                <Typography variant="body2" style={{fontWeight: 500}}>
                  {this.props.amount_paid_on}
                </Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Amount</Typography>
              </td>

              <td>
                <Typography variant="body2" style={{fontWeight: 500}}>
                  {this.props.amount_paid}
                </Typography>
              </td>
            </tr>

           
          </tbody>
        </table>
      </div>
    );
  }
}
